import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Community from '../features/community/Community';
import CommunityNews from '../features/community/CommunityNews';
import YoutubeTrends from '../features/community/YoutubeTrends';
import NewsBriefing from '../features/stock/NewsBriefing';
import Games from '../features/lab/Games';
import AuthRedirect from '../shared/AuthRedirect';
import SubMenu from '../shared/SubMenu';
import { COMMUNITY_MENU_ITEMS } from '../config/menuConfig';

const CommunityRouter = () => {
  return (
    <>
      <SubMenu items={COMMUNITY_MENU_ITEMS} />
      <Routes>
        <Route path="/" element={<Navigate to="/announcements" replace />} />
        <Route path="/announcements" element={<Community defaultTab="announcements" />} />
        <Route path="/free-board" element={<Community defaultTab="community" />} />
        <Route path="/news" element={<CommunityNews />} />
        <Route path="/briefing" element={<NewsBriefing />} />
        <Route path="/games" element={<Games />} />
        <Route path="/youtube-trends" element={<YoutubeTrends />} />
        {/* 인증 관련 경로는 auth.ilouli.com으로 리다이렉트 */}
        <Route path="/profile" element={<AuthRedirect path="/profile" />} />
        <Route path="/login" element={<AuthRedirect path="/login" />} />
      </Routes>
    </>
  );
};

export default CommunityRouter;
